import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ResearchSecurity = () => (
  <div className="service-page">
    <Navbar />
    <div className="service-hero">
      <h1>Research &amp; Security</h1>
      <p>Proactive security research, ethical hacking, and zero-day vulnerability discovery to protect your infrastructure before threats emerge.</p>
    </div>

    <div className="service-content">
      <div className="service-grid">
        <div className="service-card">
          <div className="icon">🛡️</div>
          <h2>Ethical Hacking &amp; Penetration Testing</h2>
          <p>
            Our certified ethical hackers simulate real-world attacks against your systems,
            networks, and applications to identify vulnerabilities before malicious actors
            can exploit them.
          </p>
          <ul>
            <li>External &amp; internal network penetration testing</li>
            <li>Web application security assessments (OWASP Top 10)</li>
            <li>Mobile app security testing (iOS &amp; Android)</li>
            <li>Cloud infrastructure security reviews (AWS, GCP, Azure)</li>
            <li>Social engineering &amp; phishing simulation exercises</li>
            <li>Red team / purple team exercises</li>
            <li>Detailed remediation reports with risk scoring (CVSS)</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">🔬</div>
          <h2>Zero-Day Research</h2>
          <p>
            We conduct deep technical research into software, firmware, and protocols to
            discover unknown vulnerabilities. Our findings are disclosed responsibly to
            vendors, with CVEs assigned where applicable.
          </p>
          <ul>
            <li>Binary analysis &amp; reverse engineering (x86, ARM, MIPS)</li>
            <li>Fuzz testing &amp; concolic execution</li>
            <li>Kernel &amp; driver vulnerability research</li>
            <li>Web &amp; mobile platform bug hunting</li>
            <li>IoT &amp; embedded system security analysis</li>
            <li>Responsible disclosure &amp; CVE coordination</li>
            <li>Proof-of-concept exploit development</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">📋</div>
          <h2>Security Audits &amp; Compliance</h2>
          <p>
            Comprehensive security audits that assess your organisation's posture against
            industry standards and regulatory frameworks, providing clear roadmaps for
            improvement.
          </p>
          <ul>
            <li>ISO 27001 gap analysis &amp; readiness assessment</li>
            <li>POPIA &amp; GDPR compliance audits</li>
            <li>PCI-DSS compliance validation</li>
            <li>SOC 2 Type I &amp; Type II preparation</li>
            <li>Security architecture review</li>
            <li>Policy, procedure &amp; governance assessment</li>
            <li>Vendor &amp; third-party security reviews</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">🌐</div>
          <h2>Threat Intelligence &amp; Monitoring</h2>
          <p>
            Stay ahead of emerging threats with curated threat intelligence, continuous
            monitoring, and proactive defence strategies tailored to your industry and
            attack surface.
          </p>
          <ul>
            <li>Threat feed aggregation &amp; contextual analysis</li>
            <li>Dark web monitoring &amp; brand intelligence</li>
            <li>Indicators of compromise (IoC) collection &amp; correlation</li>
            <li>SIEM rule development &amp; tuning (Splunk, ELK, Sentinel)</li>
            <li>Attack surface management &amp; exposure mapping</li>
            <li>Incident response planning &amp; tabletop exercises</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">📘</div>
          <h2>Research Publications &amp; Advisories</h2>
          <p>
            Our research team publishes in-depth technical reports, security advisories, and
            whitepapers covering vulnerability disclosures, exploit techniques, and defensive
            strategies.
          </p>
          <ul>
            <li>Vulnerability disclosure advisories (with CVE IDs)</li>
            <li>Technical deep-dives &amp; exploit analysis</li>
            <li>Industry-specific threat landscape reports</li>
            <li>Tooling &amp; framework development for security research</li>
            <li>Conference talks &amp; community contributions</li>
            <li>Custom research engagements for your stack</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">🎓</div>
          <h2>Security Training &amp; Awareness</h2>
          <p>
            Build a security-first culture in your organisation. We offer hands-on training
            programmes for developers, IT teams, and executives.
          </p>
          <ul>
            <li>Secure coding workshops (Web, Mobile, Cloud)</li>
            <li>CTF-style capture-the-flag exercises</li>
            <li>Phishing awareness &amp; reporting programmes</li>
            <li>Incident response &amp; forensics training</li>
            <li>Executive security briefings &amp; risk communication</li>
            <li>Custom curriculum design for your tech stack</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="service-cta">
      <h2>Strengthen your security posture</h2>
      <p>Whether you need a penetration test, zero-day research, or compliance audit — we're ready to help.</p>
      <a href="mailto:kwuimi@qmxtechnology.com" className="cta">Contact Our Security Team</a>
    </div>

    <Footer />
  </div>
);

export default ResearchSecurity;
